import { Component, inject } from '@angular/core';

import { DisablePostForToastService } from '#core/services/disable-post-for-toast.service';
import { LayoutService } from '#core/services/layout.service';

@Component({
  selector: 'di-layout',
  templateUrl: './layout.component.html',
  standalone: false,
  host: {
    class: 'tw:flex tw:flex-col tw:flex-1 tw:h-full tw:px-5',
  },
})
export class LayoutComponent {
  private readonly layoutService = inject(LayoutService);
  // Injected to trigger toast notifications for disabled services on authenticated pages
  private readonly disablePostForToastService = inject(DisablePostForToastService);

  constructor() {
    this.layoutService.trackRouterChanges();
  }
}
